<template>
    <div class="spiner-wrap" v-show="visible">
        <div style="display: flex;justify-content: space-between;">
            <div class="spiner-box-item-flex" v-for="item in content" :key="item.id">
                <div class="item-title">
                    <span class="title-icon"></span>
                    <span>{{ item.title }}</span>
                </div>
                <div v-for="(el,index) in item.contentList" :key="index" class="link-content" @click="handleView(el)">{{ el.label }}</div>
            </div>
        </div>
        <div class="spiner-bottom">
            <el-button type="text" @click="close"><i class="el-icon-close" style="margin-right: 3px;"></i>关 闭</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name:"spinerDiv",
    props:["content", "visible"],
    data(){
        return {

        }
    },
    methods:{
        handleView(val){
            if(val.type == 1 && val.url) window.location.href = val.url
        },
        close(){
            this.$emit('closeNav',true)
        }
    }
}
</script>

<style lang="scss">
.spiner-wrap{
    position: absolute;
    border-radius: 3px;
    box-shadow: 0px 0px 5px 1px #d0d4da62;
    z-index: 9999;
    transition: all .3s;
    left: 8.2rem;
    top:0.76rem;
    background-image: url('../assets/images/2025new/navBg.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.spiner-bottom{
    width: 100%;
    display: flex;
    justify-content: center;
    .el-button{
        font-size: 0.14rem;
        position: relative;
        bottom:0.05rem;
    }
}
.spiner-box-item-flex{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin: 0.12rem 0.4rem;
    .title-icon{
        display: inline-block;
        width: 0.03rem;
        height: 0.18rem;
        position: relative;
        top:0.03rem;
        border-radius: 3px;
        background: #0061E3;
        margin-right: 0.06rem;
    }
    .item-title{
        font-size: 0.16rem;
        color: #333;
        font-weight: 600;
        margin-bottom:0.1rem;
    }
    .link-content{
        font-size: 0.14rem;
        color: #606266;
        margin: 0.1rem 0;
        cursor: pointer;
    }
    .link-content:hover{
        color: #0061E3;
        font-weight: 600;
    }
}
</style>